import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: 'Tên đời thiết bị',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'deviceSKUCode',
        headerName: 'Tên SKU thiết bị',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.deviceSKU?.name} />
        ),
    },
    {
        field: 'deviceGroupCode',
        headerName: 'Tên nhóm thiết bị',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.deviceGroup?.name} />
        ),
    },
    {
        field: 'deviceTypeCode',
        headerName: 'Tên loại thiết bị',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.deviceType?.name} />
        ),
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
];
